import { useTitle, Overlay } from "modules/common";
import React from "react";

export const InteractiveMap: React.FC = () => {
    useTitle("Interaktivna karta - eSavjetnik");

    return (
        <Overlay
            fullScreenInitially
            view={{
                title: "Interaktivna karta",
                source: "interaktivna-karta",
            }}
        />
    );
};
